import { render, staticRenderFns } from "./ModalCambioPaquete.vue?vue&type=template&id=1e854caf"
import script from "./ModalCambioPaquete.vue?vue&type=script&lang=js"
export * from "./ModalCambioPaquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports